import { DataSourceSummary } from "../../api/models/DataSource";
import TileViewSection from "./TileViewSection";

export type DataSourcesTileViewProps = {
    dataSources: DataSourceSummary[];
    onRowClick: (id: number) => void;
    orderBy?: string;
    onOrderBy: (orderBy: string) => void;
    sortOrder?: string;
};

const DataSourcesTileView = ({ dataSources }: DataSourcesTileViewProps) => {
    const manualOnlyDataSources = dataSources.filter(
        (_) => !_.connectionTypeName
    );
    const customApiConnectedDataSources = dataSources.filter(
        (_) => _.connectionTypeName === "Custom"
    );
    const enterpriseConnectedDataSources = dataSources.filter(
        (_) => _.connectionTypeName && _.connectionTypeName !== "Custom"
    );

    return (
        <div className="space-y-6">
            <TileViewSection
                title="Enterprise connections"
                dataSources={enterpriseConnectedDataSources}
                emptyStateMessage="No enterprise connections yet"
            />
            <TileViewSection
                title="Custom connections"
                dataSources={customApiConnectedDataSources}
                emptyStateMessage="No custom connections yet"
            />
            <TileViewSection
                title="Manual entry"
                dataSources={manualOnlyDataSources}
                emptyStateMessage="No manual entries yet"
            />
            <TileViewSection
                title="Third party connections"
                dataSources={[]}
                emptyStateMessage="No external connections yet"
            />
        </div>
    );
};

export default DataSourcesTileView;
